import { render, staticRenderFns } from "./export-rounded.vue?vue&type=template&id=2854abc4&"
import script from "./export-rounded.vue?vue&type=script&lang=js&"
export * from "./export-rounded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2854abc4')) {
      api.createRecord('2854abc4', component.options)
    } else {
      api.reload('2854abc4', component.options)
    }
    module.hot.accept("./export-rounded.vue?vue&type=template&id=2854abc4&", function () {
      api.rerender('2854abc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/export-rounded.vue"
export default component.exports